import { dataHooks as createDataHooks } from '@wix/data-hooks'

export const dataHooks = createDataHooks<{
  subTitleAbove: {}
  title: {}
  subTitleBelow: {}
  skip: {}
}>('common-template')
